/*
* 各商材別申込書

content
├ application_main.js (メイン処理)
├ _common.js (共通関数)
├ _itzai.js
├ _ec.js
├ _wel.js(リロ・wel)
└ html
  ├ application_html.js(共通HTML)
  ├ _itzai.js
  ├ _ec.js
  └ _wel.js(リロ・wel)
*/ 
import applicationCommonClass from "./common.class"
import applicationItzaiClass, { isAnyItzaiProductChecked } from "./itzai.class";
import applicationECClass from "./ec.class";
import applicationWELClass from "./wel.class";
import applicationReloClass from "./relo.class";
import applicationSEOClass from "./seo.class";
import applicationMEOClass from "./meo.class";
import applicationInternalMEOClass from "./internalMeo.class";
import applicationCMSClass from "./cms.class";
import applicationCMSLodgingClass from "./cmsLodging.class";
import applicationSubsidyClass from "./subsidy.class";
import applicationVideoProductionClass from "./videoProduction.class";
import applicationJOBYClass from "./JOBY.class";
import applicationOptionClass from "./option.class";
import applicationSeoMeoPackClass, {
  SEO_MEO_PACK_PLANS,
  applySeoMeoPackTrainPeriodLock,
  resetSeoMeoPackTrainPeriodLock,
} from "./seoMeoPack.class";
import applicationJobDetailsClass from "./jobDetails.class";
import applicationContactInfoClass from "./contactInfo.class";

const isCorporateCompletePlanId = (planId) =>
  planId === 'itzai_plan_corporate' ||
  planId === 'itzai_plan_complete'
const isCmsOrderedAsProduct = ($) => !!$('#formCMSSelect').prop('checked')

class main {
  constructor(vueObj, $, func, moment, store) {

    try {
      // Vueインスタンスを取得
      this.vueObj = vueObj

      this.store = vueObj.store

      this.isProd = this.vueObj.isProd

      // jQueryインスタンスを取得
      this.$ = $

      // フォーム関連関数を取得
      this.func = func

      // momentインスタンスを取得
      this.moment = moment

      // propsを取得
      //this.props = this.vueObj.getProps()
      this.thisFormParams = vueObj.thisFormParams

      // 投稿先slackチャンネル情報
      this.slackChannel = vueObj.slackChannel
      this.demo = this.isProd ? "" : "Demo"
      this.key = this.store.state.apis[`loginKey${this.demo}`]

      // 案件ID検索とか理由カテゴリ取得するAPI
      this.getDataApiURL = this.store.state.apis.getDataApiURL

      // talknoteのグループURLからグループIDを取得
      //this.groupID = this.groupURL.split('feed/')[1].split('/')[0]

      // フォームタイトル
      this.groupTitle = this.thisFormParams[0].replace(/\n/gi,"").replace(/\t/gi,"")

      // talknoteの投稿先アドレス
      // this.talknoteGroupAddress = this.thisFormParams[2].replace(/\n/gi,"").replace(/\t/gi,"")

      // slackチャンネルURL
      this.groupURL = this.slackChannel.workSpaceURL + this.slackChannel.id 

      // axios
      this.axios = vueObj.axios

      this.formType = 0 // [1:イツザイ, 2:EC, 3:リロ・WEL]
      this.formTypeName = '' 
      this.appClassObj = {}

      // [本日]
      this.today = moment()
      this.today = this.today.format('YYYY-MM-DD')

      // store
      this.store = store

      this.appClassObj.common = new applicationCommonClass.commonFuncs(this)

      // 初期化
      this.init()

    } catch(e) {
      console.error(e.stack, e.message)

      let text = []

      if(!this.vueObj) {
        text.push('Vueインスタンスが取得できませんでした。')
      }

      if(!this.$) {
        text.push('jQueryが取得できませんでした。')
      }

      if(text.length == 0) {
        alert('予期せぬエラーが発生しました。')
      } else {
        alert(text.join('\n'))
      }

      return false
    }

  }

  applySeoMeoPackPlan(planName) {
    const $ = this.$
    const that = this
    const planConfig = SEO_MEO_PACK_PLANS[planName]
    if (!planConfig) return

    this.vueObj.isFormApplicationSEO = true
    this.vueObj.isFormApplicationMEO = true

    this.vueObj.$nextTick(() => {
      if (!that.appClassObj.seos) {
        that.appClassObj.seos = new applicationSEOClass.afrPostSEO(that)
      }
      if (!that.appClassObj.meos) {
        that.appClassObj.meos = new applicationMEOClass.afrPostMEO(that)
      }
      applySeoMeoPackTrainPeriodLock($)
      that.func.actionInit($)
    })
  }

  resetSeoMeoPackPlanEffects() {
    const $ = this.$

    $('input[name="seo_meo_pack_plan"]').prop('checked', false)
    resetSeoMeoPackTrainPeriodLock($)

    if (!$('#formSEOSelect').prop('checked')) {
      this.vueObj.isFormApplicationSEO = false
      this.appClassObj.seos = null
    }
    if (!$('#formMEOSelect').prop('checked')) {
      this.vueObj.isFormApplicationMEO = false
      this.appClassObj.meos = null
    }
  }

  init() {
    const $ = this.$;
    
    $('.search_form_wrap').show()
    $('.autoG,.gotAP, .item, .form_wrap').css('display', 'none')
    $('#sendDate, #callDate').addClass('required').removeAttr('style')
    $('select').prop('selectedIndex', 0)
    this.actionInit();

    this.getIndustryNamesData();
    $(".test_marketing_authority").hide()

  }

  actionInit() {
    const that = this
    const $ = this.$
    const moment = this.moment
    moment.locale("ja")

    if (that._seoMeoPackPlanHandler) {
      document.removeEventListener('seoMeoPackPlanChange', that._seoMeoPackPlanHandler)
    }
    that._seoMeoPackPlanHandler = (event) => {
      if ($('#formSeoMeoPackSelect').prop('checked')) {
        that.applySeoMeoPackPlan(event.detail)
      }
    }
    document.addEventListener('seoMeoPackPlanChange', that._seoMeoPackPlanHandler)

    $('.select_checkbox').on('change', async function() {
      const formId = $(this).val().replace('Select', '')

      let toggle = $(this).prop('checked')

      const itzaiOn = isAnyItzaiProductChecked($)
      const itzaiToggle = formId === 'itzai' ? itzaiOn : toggle
      //that.vueObj.hideSelectAllForm()
      
      //if(!formId) $('.search_form_wrap').hide()
      await that.vueObj.toggleSelectForm(formId, formId === 'itzai' ? itzaiToggle : toggle)
      

      if (!toggle) {
        // 補助CMSフォーム中：受注CMSをOFFにしても入力中のため delValue しない（store をクリアしない）
        if (formId === 'cms') {
          const planId = $('[name="itzai_plan"]:checked').prop('id') || ''
          const isAuxiliaryCmsForm =
            isCorporateCompletePlanId(planId) && isAnyItzaiProductChecked($)
          if (!isAuxiliaryCmsForm) {
            that.store.commit('delValue', formId)
          }
        } else if (formId === 'itzai') {
          if (!isAnyItzaiProductChecked($)) {
            that.store.commit('delValue', 'itzai')
          }
        } else {
          that.store.commit('delValue', formId)
        }
      }

      let elm = {}
      $('#formContactInfo .form_wrap').show()
      that.appClassObj.contactInfo = new applicationContactInfoClass.afrContactInfo(that)

      switch (formId) {

        case 'itzai':
          elm = $('#formItzai .form_wrap')

          if(itzaiOn) {
            elm.show()
            that.appClassObj.itzai = new applicationItzaiClass.afrPostItzai(that)
          } else {
            elm.hide()
            that.appClassObj.itzai = null
            // 補助CMSフォームのみのときはイツザイOFFで CMS ブロックも閉じる（受注CMS未選択時）
            if (!isCmsOrderedAsProduct($)) {
              that.vueObj.isFormApplicationCMS = false
              $('#formCMS .form_wrap').hide()
              if (that.appClassObj.cms) {
                that.appClassObj.cms = null
              }
            }
          }
          
          break

        case 'ec':
          elm = $('#formEC .form_wrap')
          
          if(toggle) {
            elm.show()
            that.appClassObj.ec = new applicationECClass.afrPostEC(that)
          } else {
            elm.hide()
            that.appClassObj.ec = null
          }
        
          break
        
        case 'wel':
          elm = $('#formWel .form_wrap')
          
          if(toggle) {
            elm.show()
            that.appClassObj.wel = new applicationWELClass.afrPostWel(that)
          } else {
            elm.hide()
            that.appClassObj.wel = null
          }
          
          break

        case 'relo':
          elm = $('#formRelo .form_wrap')
          
          if(toggle) {
            elm.show()
            that.appClassObj.relo = new applicationReloClass.afrPostRelo(that)
          } else {
            elm.hide()
            that.appClassObj.relo = null
          }
          
          break
        
        case 'seo':
          elm = $('#formSEO .form_wrap')
          
          if(toggle) {
            elm.show()
            that.appClassObj.seos = new applicationSEOClass.afrPostSEO(that)
          } else {
            elm.hide()
            that.appClassObj.seos = null
          }
          
          break
        
        case 'meo':
          elm = $('#formMEO .form_wrap')
          
          if(toggle) {
            elm.show()
            that.appClassObj.meos = new applicationMEOClass.afrPostMEO(that)
          } else {
            elm.hide()
            that.appClassObj.meos = null
          }
          
          break

        case 'internalMeo':
          elm = $('#formInternalMEO .form_wrap')
          
          if(toggle) {
            elm.show()
            that.appClassObj.internalMeos = new applicationInternalMEOClass.afrPostInternalMEO(that)
          } else {
            elm.hide()
            that.appClassObj.internalMeos = null
          }
          
          break

        case 'seoMeoPack':
          elm = $('#formSeoMeoPack .form_wrap')

          if(toggle) {
            elm.show()
            $('#formSEOSelect, #formMEOSelect').prop({ checked: false, disabled: true })
            that.appClassObj.seoMeoPack = new applicationSeoMeoPackClass.afrPostSeoMeoPack(that)
            const selectedPlan = $('input[name="seo_meo_pack_plan"]:checked').val()
            if (selectedPlan) {
              that.applySeoMeoPackPlan(selectedPlan)
            }
          } else {
            elm.hide()
            $('#formSEOSelect, #formMEOSelect').prop('disabled', false)
            that.appClassObj.seoMeoPack = null
            that.resetSeoMeoPackPlanEffects()
          }

          break

        case 'cms':
          // 受注で CMS にチェック → 通常どおり表示。OFF 時も補助CMSフォーム対象プランなら表示維持（itzaiCmsFormRules）
          elm = $('#formCMS .form_wrap')
          
          if(toggle) {
            elm.show()
            if (!that.appClassObj.cms) {
              that.appClassObj.cms = new applicationCMSClass.afrPostCMS(that)
            }
          } else {
            const planId = $('[name="itzai_plan"]:checked').prop('id') || ''
            const keepForAuxiliaryCmsForm =
              isCorporateCompletePlanId(planId) && isAnyItzaiProductChecked($)
            if (keepForAuxiliaryCmsForm) {
              elm.show()
              if (!that.appClassObj.cms) {
                that.appClassObj.cms = new applicationCMSClass.afrPostCMS(that)
              }
            } else {
              elm.hide()
              that.appClassObj.cms = null
            }
          }
          
          break

        case 'cms_lodging':
          elm = $('#formCMSLodging .form_wrap')
          
          if(toggle) {
            elm.show()
            that.appClassObj.cmsLodging = new applicationCMSLodgingClass.afrPostCMSLodging(that)
          } else {
            elm.hide()
            that.appClassObj.cmsLodging = null
          }
          
          break

        case 'JOBY':
          elm = $('#formJOBY .form_wrap')
          
          if(toggle) {
            elm.show()
            that.appClassObj.JOBY = new applicationJOBYClass.afrPostJOBY(that)
          } else {
            elm.hide()
            that.appClassObj.JOBY = null
          }
          
          break

        case 'subsidy':
          elm = $('#formSubsidy .form_wrap')
          
          if(toggle) {
            elm.show()
            that.appClassObj.subsidy = new applicationSubsidyClass.afrPostSubsidy(that)
          } else {
            elm.hide()
            that.appClassObj.subsidy = null
          }
          
          break

        case 'video_production':
          elm = $('#formVideoProduction .form_wrap')
          
          if(toggle) {
            elm.show()
            that.appClassObj.video_production = new applicationVideoProductionClass.afrPostVideoProduction(that)
          } else {
            elm.hide()
            that.appClassObj.video_production = null
          }

          break

        case 'option':
          elm = $('#formOption .form_wrap')
          
          if(toggle) {
            elm.show()
            that.appClassObj.option = new applicationOptionClass.afrPostOption(that)
          } else {
            elm.hide()
            that.appClassObj.option = null
          }
          
          break

      }

      if (that.appClassObj.itzai != null || that.appClassObj.JOBY != null) {
        $('#formJobDetails .form_wrap').show()
        that.appClassObj.jobDetails = new applicationJobDetailsClass.afrPostJobDetails(that)
      } else {
        $('#formJobDetails .form_wrap').hide()
        that.appClassObj.jobDetails = null
      }

      const paymentStatus = $('#paymentStatus option:selected').data('status')

      switch(paymentStatus) {
        case 'done':
          $('.progress_display').show()
          $('.progress_display input[type="radio"]').addClass('required')
          break

        case 'doing':
          $('.progress_display').show()
          $('.progress_display input[type="radio"]').addClass('required')
          break

        case 'notYet':
          $('.progress_display').hide()
          $('.progress_display input[type="radio"]').removeClass('required').prop('checked', false)
          break
      }

      that.func.actionInit($);

      //$('#saledPlan').val(that.formTypeName)
      $('#loading_form').css('display', 'none')

      //$('select').css('display', 'block')

      //that.func.clearSelect($('#form_ap #paymentStatus'))
      //formDataStore.commit('setAppClassObj', 1);
      //console.log(formDataStore.state.appClassObj.test());
    })
    
    
    $('#btn').off('click.send').on('click.send', async function () {
      if($('#btn').hasClass('pulse')) {
        let balanceInfo_len = $('.balanceInfo').length
        let $balanceInfo_balance = $('.balanceInfo_balance')
        let $balanceInfo_date = $('.balanceInfo_date')
        let $balanceInfo_paymentMethod = $('.balanceInfo_paymentMethod')
        let paymentStatus = $('#paymentStatus option:selected').val()

        let balanceNum = 0
        let balanceInfoMsg = ''
        let Info_balance = 0
        let Info_date = ''
        let Info_paymentMethod = 0
        let isInputFlag = 1
        let inputBalances_ary = []
        let balanceInfoObj = {
          "残額": [],
          "残額期日": [],
          "支払い方法": []
        }
        
        for(let i = 0; i < balanceInfo_len; i++) {
          let obj = {}
          $balanceInfo_balance[i].value == "" ? isInputFlag *= 0 : Info_balance = $balanceInfo_balance[i].value

          $balanceInfo_date[i].value == "" ? isInputFlag *= 0 : Info_date = $balanceInfo_date[i].value

          $balanceInfo_paymentMethod[i].value == "" ? Info_paymentMethod *= 0 : Info_paymentMethod = $balanceInfo_paymentMethod[i].value
      
          if( isInputFlag == 1 ) { //残額・残額期日・支払い方法の3つの入力された時
            let totalInfo_balance = Number(that.store.state.totalInfo_balance) + that.func._removeComma(Info_balance)
            //that.store.commit('setValue',['totalInfo_balance', totalInfo_balance])

            Info_date = moment(Info_date.split('/').join('-')).format('YYYY/MM/DD（ddd）')

            obj.balance = Info_balance + '円'
            obj.paymentMethod = Info_paymentMethod
            obj.balanceDeadline = Info_date

            balanceNum += 1
            balanceInfoMsg +=
            '(' + balanceNum + ')' + '\n' +
            '残額：' + Info_balance + '円' +'\n' +
            '残額期日：' + Info_date + '\n' +
            '支払い方法：' + Info_paymentMethod + '\n'

            balanceInfoObj["残額"].push(Info_balance)
            balanceInfoObj["残額期日"].push(Info_date)
            balanceInfoObj["支払い方法"].push(Info_paymentMethod)
            that.store.commit('setValue', ['common', 'totalInfo_balance', totalInfo_balance, 'total_balance'])

          } else if(paymentStatus == '決済完了') {
            that.store.commit('setValue', ['common', 'totalInfo_balance', '0', 'total_balance'])
          }
          
          inputBalances_ary.push(obj)
        }
  
        that.store.commit('setValue', ['common', 'balance_Info', balanceInfoObj, 'total_balance'])
        that.store.commit('setValue',['common', 'balances', inputBalances_ary, 'balances'])

        balanceInfoMsg = balanceInfoMsg.slice(0, -1)

        // 「受注内容」構築
        let formTypeName = []
        let sorter = ['itzai', 'ec', 'wel', 'relo', 'seoMeoPack', 'seos', 'meos', 'internalMeos', 'cms', 'cmsLodging', 'subsidy', 'video_production', 'JOBY', 'option']
        for(let key in sorter) {
          if (that.appClassObj[sorter[key]]) { // クラスが宣言されている時
            if(key != "common") {
              // 受注として CMS を選んだときだけ「CMS」を受注内容に含める（補助CMSフォームのみでは含めない）
              if (sorter[key] === 'cms' && !isCmsOrderedAsProduct($)) {
                continue
              }
              // パック受注時は SEO/MEO を個別商材名として重複表示しない
              if (that.appClassObj.seoMeoPack && (sorter[key] === 'seos' || sorter[key] === 'meos')) {
                continue
              }
              formTypeName.push(that.appClassObj[sorter[key]].returnFormName())
            }
          }
        }

        that.store.commit('setValue',['common', 'formTypeName', formTypeName.join('+'), 'formTypeName'])

        // 「シート用」 「talknote用」のデータ構築
        for(let key in that.appClassObj) {
          if (that.appClassObj[key]) {
            that.appClassObj[key].getInputData()
            that.appClassObj[key].setVal(balanceInfoMsg)
          }
        }

        const msg = that.appClassObj.common.getDataToTalknote()
        const sheetdata = that.appClassObj.common.getDataToSheet()

        await that.appClassObj.common.sendFormData(msg, sheetdata)
        await that.appClassObj.common.clearAllOption()

        //$('.form_list').hide()
      }
    })

    console.log('main init');
  }

  //申込書イツザイ 業界名データ取得
  async getIndustryNamesData() {
    // メアドでtalknoteのユーザーID取得
    const getCategoriesApiURL = this.store.state.apis[`dbApiURL${this.demo}`] + 'db/select'
    
    this.abortController = new AbortController()

    const params = {
      authC: {
        password: "W!z|a~.x.T~Tzca8CBCm",
        mail: 'system@sungrove.co.jp'
      },
      main_data: {
        tables:["categories"],
        query: `SELECT id, name FROM categories c WHERE c.counterparts_id = 25 AND c.deleted_at is NULL` // イツザイの業種カテゴリを取得
      },
      support_data: {
        is_prod: 1 // 開発環境でも本番を参照
      }
    }

    fetch(getCategoriesApiURL, {
      signal: this.abortController.signal,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Cal-St-Api': this.key
      },
      body: JSON.stringify(params)
    })
    .then(response => response.json())
    .then(res => {
      console.log(res);

      this.store.commit('setIndustryNamesData', res);
    })
    .catch(err => {
      alert('業界リストを取得できませんでした。');
      console.log(err);
    });
  }
}

export default {
  main
}
